<div class="main-card mb-3 card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span class="font-weight-bold fs-1r"> Bids</span>
  </div>

  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead>
        <tr>
          <th>Created By</th>
          <th>Phone Number</th>
          <th>Comment</th>
          <th>Driver Name</th>
          <th>Driver Phone</th>
          <th>Created At</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let data of allBids
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <td>
            {{ data.createdBy?.firstName }} {{ data.createdBy?.lastName }}
          </td>
          <td>{{ data.createdBy?.phoneNumber }}</td>
          <td>{{ data.comment }}</td>
          <td>{{ data.driver?.firstName }} {{ data.driver?.lastName }}</td>
          <td>{{ data.driver?.phoneNumber }}</td>
          <td>{{ data.createdAt }}</td>
          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-sm btn-warning dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <a class="dropdown-item" (click)="openEditPlan(data)">Edit</a>
                </li>
                <li>
                  <a
                    class="dropdown-item text-danger"
                    (click)="deleteSubscription(data)"
                    >Delete</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
        <div *ngIf="allBids?.length == 0" class="text-center mt-5 mb-5">
        <span class="text-danger">Data Not found</span>
      </div>
    </table>

    <!-- Pagination -->
    <!-- <ngb-pagination
      (pageChange)="getRequests(activeTab, (page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination> -->
  </div>
</div>
